var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pb-8"},[_c('v-col',[_c('carousel'),_c('session-title',{staticClass:"pt-8 px-8 pb-0",attrs:{"title":"Elogios Recebidos"}}),_c('compliment-cards')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }